import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import NoDeviceButton from '../NoDeviceButton';
import styles from '../../DeviceLinks.module.css';
import Form from 'react-bootstrap/Form';
import { Field, FormikProvider } from 'formik';
import { Button, ValidatedFormInputField } from 'ui';
import { ReactComponent as Mail } from 'images/input_mail.svg';
import { setButtonVariant } from 'utils/utilities';
import { useResendCountdown } from 'features/common/hooks';
import useEmailForm from './useEmailForm';

const Email = ({ theme, navigate, isReauthenticate, stopPolling, sentAt, onSent }) => {
    const { formik } = useEmailForm({ isReauthenticate, onSent });
    const { handleSubmit, isSubmitting } = formik;

    const { active: success, secs } = useResendCountdown(sentAt);

    return (
        <FormikProvider value={formik}>
            <Form noValidate onSubmit={handleSubmit}>
                <Card.Body style={{ padding: '24px 0px 0px' }} className={styles.body}>
                    <h4 className={styles.PassportCardHeading}>
                        {success
                            ? 'Successfully sent a link on your email'
                            : 'Receive a link via email'}
                    </h4>
                    <p className={styles.PassportCardSubheading}>
                        {success
                            ? 'Please open the link we have sent on your email address'
                            : 'Enter your email address and we will send you a link to complete this verification on a mobile device.'}
                    </p>
                    {success ? (
                        <span className="text-muted" style={{ fontSize: '12px' }}>
                            {`You can again retry in ${secs} seconds`}
                        </span>
                    ) : (
                        <div>
                            <Field
                                component={ValidatedFormInputField}
                                type="text"
                                name="email"
                                variant={theme?.textInputVariant}
                                StartAdornmentIcon={Mail}
                                placeholder="your@email.com"
                                label="Email Address"
                                className={styles.phoneNumber}
                            />
                            <div
                                className="text-muted"
                                style={{ fontSize: '12px', paddingTop: '35px' }}
                            >
                                If you do not see the email, then please check your spam folder.
                            </div>
                        </div>
                    )}
                </Card.Body>
                <Card.Footer
                    style={{
                        padding: '16px 0px 0px',
                        border: 'none',
                        background: 'none',
                    }}
                    className="text-muted"
                >
                    <Button
                        block
                        className={styles.passportFooterBtn}
                        disabled={success || isSubmitting}
                        variant={setButtonVariant(theme?.button?.variant)}
                        type="submit"
                    >
                        Send Link
                    </Button>
                    {!isReauthenticate && (
                        <NoDeviceButton navigate={navigate} stopPolling={stopPolling} />
                    )}
                </Card.Footer>
            </Form>
        </FormikProvider>
    );
};

Email.propTypes = {
    theme: PropTypes.object,
    navigate: PropTypes.func,
    isReauthenticate: PropTypes.bool,
    stopPolling: PropTypes.func,
    sentAt: PropTypes.number,
    onSent: PropTypes.func,
};

export default Email;
